module.exports = __webpack_public_path__ + "static/urm-08698d7cab68cabd220cacf4de7e9d1b.png";